angular.module('satv.track')
    .controller('BaseSelectModalCtrl', ['$scope', 'Loader', 'FormModal', function ($scope, Loader, FormModal) {
        'use strict';

        $scope.selected = null;
        $scope.terms = {};

        $scope.search = function (terms) {
            $scope.loader = new Loader(terms).getFirstPage();
        };

        $scope.setSelected = function (model) {
            $scope.selected = model;
        };

        $scope.isSelected = function (model) {
            return model === $scope.selected;
        };

        $scope.submit = function (model) {
            $scope.$close(true, model);
        };

        $scope.create = function () {
            FormModal.open({
                success: function (r) {
                    $scope.submit(r[1]);
                }
            });
        };

        $scope.edit = function (model) {
            FormModal.open({
                success: function () {
                    $scope.loader.getFirstPage();
                }
            }, {
                model: angular.copy(model)
            });
        };

        // $scope.search($scope.terms);
    }]);




// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/controllers/BaseSelectModalCtrl.js